import { Injectable } from '@angular/core';
import { ApplicationModel, ApplicationVersions, LandingModel, LandingNameItem } from 'app/common/models/common.model';
import { BackEndCommunicationService } from 'app/common/services/beComm.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {
  constructor(
    private backEndCommunicationService: BackEndCommunicationService,
    private http: HttpClient
  ) {}

  /* PUBLIC */
  public getApplicationByIdP = (url: string): Observable<any> => {
    return this.backEndCommunicationService.getResourceObservable(`/applications/public/${url}`);
  };

  /* LANDINGS */
  public getLandingNames = (): Observable<LandingNameItem[]> => {
    return this.backEndCommunicationService.getResourceObservable('/landings/names');
  };

  /* PRIVATE */
  public getApplicationById = (id: string): Observable<ApplicationModel> => {
    return this.backEndCommunicationService.getResourceObservable(`/applications/${id}`);
  };
  public getApplicationVersionById = (
    id: string,
    versionId: string
  ): Observable<ApplicationVersions> => {
    return this.backEndCommunicationService.getResourceObservable(
      `/applications/${id}/versions/${versionId}`
    );
  };

  createDeal(data): Observable<any> {
    return this.backEndCommunicationService.postResourceObservable('/deal', { json: data });
  }

  public addToLibrary = (id: string): Observable<ApplicationModel> => {
    const data = {};
    return this.backEndCommunicationService.postResourceObservable(
      `/applications/${id}/lastversion`,
      data
    );
  };
  public removeFromLibrary = (id: string): Observable<ApplicationModel> => {
    return this.backEndCommunicationService.deleteResourceObservable(`/applications/${id}`);
  };
  public sendLastVersion = (applicationId: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const data = {};
      this.backEndCommunicationService
        .postResource(`/applications/${applicationId}/lastversion`, data)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject('Unknown error creating os version');
        });
    });
  };

  getLandingsList(): Observable<LandingModel[]> {
    return this.backEndCommunicationService.getResourceObservable('/landings');
  }

  getAllApplicationsLanding = (landingId): Observable<LandingModel> => {
    return this.backEndCommunicationService.getResourceObservable(`/landings/${landingId}`);
  };
  public getApplicationsSearch = (
    search,
    from?,
    size?,
    filter?,
    categoryId?
  ): Observable<ApplicationModel[]> => {
    //applications?filter=all&from=&size=&search=&categoryId=${categryComunication}
    if (filter === undefined) {
      //default value
      filter = '';
    }
    if (from === undefined) {
      //default value
      from = 0;
    }
    if (size === undefined) {
      //default value
      size = 1000;
    }

    if (categoryId) {
      return this.backEndCommunicationService.getResourceObservable(
        `/applications?filter=${filter}&search=${search}&from=${from}&size=${size}&categoryId=${categoryId}`
      );
    } else {
      return this.backEndCommunicationService.getResourceObservable(
        `/applications?filter=${filter}&search=${search}&from=${from}&size=${size}`
      );
    }
  };

  public getApplicationsSearchPaged = (
    searchName: string,
    from: number,
    size: number,
    filter: string,
    categoryId: string,
    sortColumn = '',
    sortOrder = ''
  ): Observable<{ applicationList: ApplicationModel[]; total: number }> => {
    let url = `/applications?filter=${filter}&search=${searchName}&from=${from}&size=${size}`;
    if (categoryId) {
      url += `&categoryId=${categoryId}`;
    }
    if (sortColumn) {
      url += `&sortColumn=${sortColumn}`;
    }
    if (sortOrder) {
      url += `&sortOrder=${sortOrder}`;
    }
    return this.backEndCommunicationService.getResourceObservable(url);
  };
}